import { BaseDevice, CustomLayout } from '../base_device'
import list_icon from '@/assets/img/device/mer68/Mer68_icon.png'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { mer68VKCodes } from './keycode/vkeycode'
import { getDeviceKeySquare } from './keysquare/keysquare'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { generateArray } from '@/tool/utility'

export class Mer68SESelfDev extends BaseDevice {
  name: string = 'Mer68_SE'
  icon: string = list_icon
  width: number = 732
  paddingX: number = 64
  paddingY: number = 8
  paddingBottom: number = 46

  square = getDeviceKeySquare(DevicePid.CarotmasMer68Lite)
  vkcodes = mer68VKCodes
  fnDisableKeys: KK[] = [0x00, 0x01, 0x02, 0x03, 0x04, 0x05, 0x06, 0x07, 0x08, 0x09, 0x0a, 0x0b, 0x0c, 0x1a, 0x1f, 0x20, 0x2f, 0x39, 0x3c, 0x3d, 0x3e, 0x44, 0x45, 0x46, 0x47, 0x48, 0x49]
  speedAllowValues: number[] = generateArray(0, 5)
  lightAllowValues: number[] = generateArray(0, 5)
  magneticAxis: boolean = true
  resetDes: string = ''
  lockWin: boolean = true
  minDelayTimer: number = 1
  maxDelayTimer: number = 60000
  superResponse: boolean = true

  customLayout: CustomLayout = {
    0x0d: this.createSquare(2, 2, 75),
    0x0f: this.createSquare(2, 2, 48),
    0x1c: this.createSquare(2, 2, 66.5),
    0x1e: this.createSquare(2, 2, 64),
    0x2a: this.createSquare(2, 2, 92),
    0x2d: this.createSquare(2, 2, 76),
    0x38: this.createSquare(2, 2, 80),
    0x3c: this.createSquare(2, 2, 48),
    0x3d: this.createSquare(2, 2, 48),
    0x3e: this.createSquare(2, 2, 48),
    0x41: this.createSquare(2, 2, 257),
  }

  inoperableKeys: KK[] = [0x45]

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {
    [LightEffectMode.Static_pro]: 0,
    [LightEffectMode.SaturatedStyle_pro]: 1,
    [LightEffectMode.Prosperity_1]: 3,
    [LightEffectMode.SpinningWindmill_1]: 6,
    [LightEffectMode.Scanning_1]: 5,

    [LightEffectMode.ClickHighlight_pro]: 0x11,
    [LightEffectMode.ShadowChase_pro]: 0x12,
    [LightEffectMode.KeyRipple_pro]: 0x14,
  }
}
